import Model from "@/lib/model/model";
import request from "@/lib/request/request";
import { Param } from "./params";

// aigc追问类型列表
export class AigcAskType extends Model {
  aigcAskType = ""; // Enum: "FollowupBotCommon" "FollowupBotSpeed" "INFO" "resume" "STAR"
  name = "";

  static getList() {
    return request.postInterviewApi("hr/company/aigcAskType", {}).then(resp => {
      return resp.data.data.list.map((item: any) => {
        return new AigcAskType().assign(item);
      });
    });
  }
}
export class Vir extends Model {
  canUse = 0;
  id = 0;
  imgUrl = "";
  imgUrl2 = "";
  imgUrl3 = "";
  isDefault = 0;
  name = "";
  videoUrl = "";

  static getList() {
    return request.postInterviewApi("hr/company/virVersions", {}).then(resp => {
      return resp.data.data.virVersionList.map((item: any) => {
        return new Vir().assign(item);
      });
    });
  }
}

export class CompanyInfo extends Model {
  companyId = 0;
  name = "";
  shortname = "";
  logoUrl = "";
  companyIcon = "";
  industryId = 0;
}

export class CompanyConfig extends Model {
  companyId = 0;
  stockRemainLimit = 0;
  industryId = 0;
}
export class CompanySpecialConfigNew extends Model {
  companyId = 0;
  loginBgUrl = "";
  enableParamOcr = 0;
}

export class Company extends Model {
  company = new CompanyInfo();
  companySpecialConfig = new CompanyConfig();
  companySpecialConfigNew = new CompanySpecialConfigNew();

  static get() {
    return request.postInterviewApi("hr/company/get", {}).then(resp => {
      return new Company().assign(resp.data.data);
    });
  }
  static update(data: any) {
    return request.postInterviewApi("hr/company/saveConfigNew", data);
  }
}

export class PositionItem extends Model {
  positionId = 0;
  name = "";
}

export class PositionGroup extends Model {
  positionGroupId = 0;
  positionGroupName = "";
  positions: PositionItem[] = [];

  get name() {
    return this.positionGroupName;
  }

  get positionId() {
    return -this.positionGroupId; // 防止与子节点id重复
  }

  public objectArrayClasses() {
    return {
      positions: PositionItem
    };
  }
}

export class Position extends Model {
  positionGroups: PositionGroup[] = [];

  public objectArrayClasses() {
    return {
      positionGroups: PositionGroup
    };
  }

  static get() {
    return request.postInterviewApi("hr/company/positions", {}).then(resp => {
      return new Position().assign(resp.data.data);
    });
  }
}

//心理测评量表
export class Mind extends Model {
  tacCount = 0;
  tacList: TacMind[] = [];

  public objectArrayClasses() {
    return {
      tacList: TacMind
    };
  }

  static get() {
    return request.postInterviewApi("hr/company/psycGaugeList").then(resp => {
      return new Mind().assign(resp.data.data);
    });
  }
}

export class TacMind extends Model {
  id = 0;
  name = "";
  groupName = ""; // 分组名
  groupNum = 0; // 分组序号
  introducer = ""; // 小程序介绍页
  introducerImg = ""; // 小程序介绍页图片
  descriptionDetail = ""; // 介绍
  descriptionSmall = ""; // 短介绍
  studyDuides = "";
  canDimensionSelection = 0; // 是否需要选择维度
  canQuestionGroupSelection = 0; // 是否支持分卷
  canQuestionResort = 0; // 是否题目乱序
  estimatedAnswerTime = 0;
  limitAnswerTime = "";
  remark = "";
  questionCount = 0;
  dimensionList: TacMindDimension[] = [];

  public objectArrayClasses() {
    return {
      dimensionList: TacMindDimension
    };
  }
}

export class TacMindDimension extends Model {
  id = 0;
  name = "";
  description = "";
  questionCount = 0;
}

// 信息收集默认项
export class ChoiceOption extends Model {
  name = "";
  options = [""];
}

export class Params extends Model {
  paramList: Param[] = [];
  choiceOptionList: ChoiceOption[] = [];

  public objectArrayClasses() {
    return {
      paramList: Param,
      choiceOptionList: ChoiceOption
    };
  }

  static get() {
    return request.postInterviewApi("hr/company/defaultParams").then(resp => {
      return new Params().assign(resp.data.data);
    });
  }
}

// 报告页配置包默认项
export class ReportVersion extends Model {
  versionId = 0;
  versionName = "";
  imgUrl = "";
  isHidden = false;
}

export class ReportOption extends Model {
  optionKey = "";
  optionName = "";
  optionType: "bool" | "enum" | "string" = "bool";
  enumMap = {};
  defaultValueBool = false;
  defaultValueEnum = false;
  defaultValueString = false;
}

export class ReportItemFormat extends Model {
  name = "";
  aliasName = "";
  enName = "";
  versionList: ReportVersion[] = [];
  optionList: ReportOption[] = [];
  canHidden = false;
  canResort = false;
  isSortHead = false;
  isSortTail = false;

  public objectArrayClasses() {
    return {
      versionList: ReportVersion,
      optionList: ReportOption
    };
  }
}

export class ReportConfigFormat extends Model {
  formatList: ReportItemFormat[] = [];
  formatListV6: ReportItemFormat[] = [];

  public objectArrayClasses() {
    return {
      formatList: ReportItemFormat,
      formatListV6: ReportItemFormat
    };
  }

  static get() {
    return request
      .postInterviewApi("hr/company/reportConfigFormat")
      .then(resp => {
        return new ReportConfigFormat().assign(resp.data.data);
      });
  }
}
